import { Loader } from "@googlemaps/js-api-loader"
import Price from "../directions/Price";
/**
 * Fonctionnement du calcul d'itinéraires sur un détail d'annonce.
 *
 * Toutes les dépendances proviennent du module @googlemaps/js-api-loader
 *
 * Une agence est représentée par un google place id. Si une agence ne posséde pas de google place id, le boutton Estimer
 * le coût de livraison n'est pas affiché dans le detail d'annonce.
 *
 * Le boutton Estimer le coût de livraison est désactivé jusqu'au chargement complet des API google. Au chargement des apis la classe disabled est supprimée
 *
 * Le champs utilisateur input utilise l'API Places Autocomplete. Le champs peut retourner un google place_id, dans le cas contraire doit lever une erreur
 *
 * @see: https://www.npmjs.com/package/@googlemaps/js-api-loader Npm module
 * @see: https://developers.google.com/maps/documentation/places/web-service/place-id Google place id
 * @see: https://developers.google.com/maps/documentation/javascript/places-autocomplete
 */


/**
 * Nécessite js-api-loader : npm install @googlemaps/js-api-loader
 */
window.addEventListener('DOMContentLoaded', () => {
    // Config DOMNode, built by PHP
    const CONFIG_NODE = document.getElementById('directions-config');

    // Google map, mock up a gmap node
    const MAP          = document.createElement('div');
    const CONFIG       = {
        googleMapApiKey: CONFIG_NODE.dataset.googlemapapikey,
        // Autocomplete input's DOM id
        searchInputId:   CONFIG_NODE.dataset.inputid,
        // Origin (main agency) google place_id
        fromPlaceId:     CONFIG_NODE.dataset.fromplaceid,
        // Destination (client's address) google place_id
        toPlaceId:       null,
        // Place id to place service converter
        placeDetailsService: `https://maps.googleapis.com/maps/api/place/details/json?key=${CONFIG_NODE.dataset.googlemapapikey}&place_id=`,
        // Google Place object main agency
        fromPlace:       null,
        // Google Place object client's input
        toPlace:         null,
        // CTA
        cta: null,
    };
    const SEARCH_INPUT = document.getElementById(CONFIG.searchInputId);
    const SEARCH_BUTTON = document.getElementById('modal-livraison-cta');

    if (null !== SEARCH_BUTTON) {
        CONFIG.cta = SEARCH_BUTTON;
    } else {
        throw "Cant find CTA with modal-livraison-cta id";
    }

    const loader       = new Loader({
        apiKey:    CONFIG.googleMapApiKey,
        libraries: ["places"]
    });

    loader.load().then(() => {
        // Le boutton est disponible
        CONFIG.cta.classList.remove('disabled');

        const options = {
            componentRestrictions: { country: "fr" },
            fields:                ["place_id", "address_components"],
            strictBounds:          false,
            // types:                 ["establishment"],
        };

        const autocomplete = new google.maps.places.Autocomplete(SEARCH_INPUT, options);
        const placeService = new google.maps.places.PlacesService(MAP);

        autocomplete.addListener("place_changed", () => {
            const place     = autocomplete.getPlace();
            const toPlaceId = place.place_id;

            CONFIG.toPlaceId = place.place_id;

            if(null !== toPlaceId) {
                placeService.getDetails({
                    placeId: CONFIG.fromPlaceId,
                    fields: ["geometry"],
                }, (placeResult, placeServiceStatus) => {
                    console.log(placeResult.geometry, placeServiceStatus)

                    if(placeServiceStatus === "OK") {
                        CONFIG.fromPlace = placeResult;

                        placeService.getDetails({
                            placeId: CONFIG.toPlaceId,
                            fields: ["geometry"],
                        }, (placeResult, placeServiceStatus) => {

                            const service = new google.maps.DistanceMatrixService();

                            if(placeServiceStatus === "OK") {
                                CONFIG.toPlace = placeResult;


                                service.getDistanceMatrix(
                                    {
                                        origins: [CONFIG.toPlace.geometry.location],
                                        destinations: [CONFIG.fromPlace.geometry.location],
                                        travelMode: 'DRIVING',
                                        // transitOptions: TransitOptions,
                                        // drivingOptions: DrivingOptions,
                                        unitSystem: google.maps.UnitSystem.METRIC,
                                        avoidHighways: false,
                                        avoidTolls: false,
                                    }, callback);

                                function callback(response, status) {
                                    if(response.rows.length > 0) {
                                        // Metre
                                        // console.log(response.rows[0].elements[0].distance.value)
                                        const mileage = response.rows[0].elements[0].distance.value;
                                        const price = new Price(mileage);

                                        console.log(mileage + 'm');
                                        console.log(price.getPrice() + '€');

                                        const detailsDiv = document.getElementById('modal-livraison-details');
                                        detailsDiv.innerHTML = `<span>Coût estimé: <strong>${price.price} €</strong></span>`
                                    }
                                }

                            } else {
                                // Cant bind placeId to Place
                            }
                        });

                    } else {
                        // Cant bind placeId to Place
                    }
                });
            } else {
                // Place id de destination inconnu
            }
        });
    })
        .catch(() => {
            console.log("Can't load GOOGLE apis");
        });
});
